/**
 * "Opslaan…" while change requests are pending, then briefly "Opgeslagen" when
 * a change came back (a failed change shows its own error instead).
 */
import { Check } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Spinner } from '../components/Spinner.js';
import { planningStore, usePlanningStore } from '../store/planningStore.js';
import styles from './AppShell.module.css';

const SAVED_VISIBLE_MS = 2000;

export function SavingIndicator() {
  const pending = usePlanningStore((s) => s.pending);
  const [saved, setSaved] = useState(false);
  const changeAtStart = useRef(planningStore.getState().lastChange);
  const prevPending = useRef(pending);

  useEffect(() => {
    const was = prevPending.current;
    prevPending.current = pending;
    if (was === 0 && pending > 0) {
      changeAtStart.current = planningStore.getState().lastChange;
      setSaved(false);
      return;
    }
    if (was > 0 && pending === 0 && planningStore.getState().lastChange !== changeAtStart.current) {
      setSaved(true);
      const timer = setTimeout(() => setSaved(false), SAVED_VISIBLE_MS);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [pending]);

  return (
    <span className={styles.saving} aria-live="polite">
      {pending > 0 ? (
        <>
          <Spinner size={14} label={null} />
          <span>Opslaan…</span>
        </>
      ) : saved ? (
        <>
          <Check aria-hidden="true" />
          <span>Opgeslagen</span>
        </>
      ) : null}
    </span>
  );
}
